import { udex } from '../../../scripts/dom-builder.js';
import { isL, isXL } from '../../../scripts/utils/breakpoints-utils.js';
import { ROWS_PER_PAGE } from '../finder-eccn-matrix.constants.js';
import { getTable } from './get-table.js';

let activeContainer = null;
let activeHeaders = null;
let activeData = [];
let currentPage = 0;
let resizeHandlerAttached = false;
let activePlaceholders = null;

function getDisplay() {
  return isL() || isXL() ? 'desktop' : 'mobile';
}

async function renderPage(pageIndex) {
  if (!activeContainer) {
    return;
  }

  currentPage = pageIndex;

  const totalPages = Math.ceil(activeData.length / ROWS_PER_PAGE);
  const start = pageIndex * ROWS_PER_PAGE;
  const pageRows = activeData.slice(start, start + ROWS_PER_PAGE);

  const table = await getTable(activeHeaders, pageRows, activePlaceholders);
  activeContainer.replaceChildren(table);

  if (totalPages > 1) {
    const pagination = udex('pagination', {
      pages: totalPages,
      type: 'full',
      display: getDisplay(),
      currentPageIndex: currentPage,
    });

    pagination.addEventListener('change', () => {
      renderPage(Number(pagination.currentPageIndex));
    });

    activeContainer.append(pagination);
  }
}

export function buildTableAndPagination(
  container,
  headers,
  data,
  placeholders,
) {
  activeContainer = container;
  activeHeaders = headers;
  activeData = data;
  activePlaceholders = placeholders;

  renderPage(0);

  if (!resizeHandlerAttached) {
    resizeHandlerAttached = true;
    window.addEventListener('resize', () => {
      renderPage(currentPage);
    });
  }
}
